<template>
    <div style="width: 100%;height: 100%">
        <label v-if="shopType === 1 || shopType === 2">
            <div v-for="(item, index) in (shopType === 1 ? service_list : service_text)" :key="index" style="padding-top: 30px; float: left">
                <div @click="addswitch(item.type)" style="float: left; margin-left: 30px; height: 35px;" :class="{ text_link: item.type === pay }">
                    <div class="codes">{{ item.name }}</div>
                    <div style="float: left">(<span>{{ item.keys }}</span>)</div>
                </div>
            </div>
        </label>
        <div style="border: 2px solid #EBEBEB;width: 100%;clear: both;"></div>
        <div style="display: flex;margin: 21px 0 0 30px;">
            <div v-if="shopType === 1" style="width: 267px;height: 38px;">
                <el-input  placeholder="输入服务名称或ID搜索" suffix-icon="el-icon-search" v-model="search"></el-input>
            </div>
            <div v-if="shopType === 2" style="width: 267px;height: 38px;">
                <el-input  placeholder="输入产品名称或ID搜索" suffix-icon="el-icon-search" v-model="search"></el-input>
            </div>
            <div v-if="shopType === 1" style="font-size: 16px;text-align: center;margin:10px 20px">服务分类</div>
            <div v-if="shopType === 2" style="font-size: 16px;text-align: center;margin:10px 20px">产品分类</div>
            <div v-if="shopType === 1" style="height: 38px;">
                <el-cascader style="width: 260px;" v-model="list" :options="type_list"></el-cascader>
            </div>
            <div v-if="shopType === 2" style="width: 260px;height: 38px;">
                <el-cascader style="width: 260px;" v-model="list" :options="TypeList"></el-cascader>
            </div>
            <div style="font-size: 16px;text-align: center;margin: 10px 20px;">价格范围</div>
            <!--   最小价格  -->
            <div style="height: 38px;">
                <el-input style="width: 110px;" placeholder="0.00" prefix-icon="el-icon-coin" type="number" v-model="minPrice"></el-input>
            </div>
            <div style="margin: 10px;">-</div>
            <!--   最大价格    -->
            <div style="height: 38px;">
                <el-input style="width: 110px;" placeholder="0.00" prefix-icon="el-icon-coin" type="number" v-model="maxPrice"></el-input>
            </div>
            <div v-if="shopType == 1" style="font-size: 16px;text-align: center;margin: 10px 20px;">服务状态</div>
            <div v-else style="font-size: 16px;text-align: center;margin: 10px 20px;">产品状态</div>
            <div style="width: 140px;height: 38px;">
                <el-select v-model="value" placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div style="width: 72px;height: 38px;margin-left: 20px;">
                <el-button plain>筛选</el-button>
            </div>
            <div v-if="shopType == 1" style="width: 170px;height: 38px;margin-left: 20px">
                <el-button class="el-icon-s-promotion" type="primary" @click="a('/shop/addGoods')">发布新服务</el-button>
            </div>
            <div v-else style="width: 170px;height: 38px;margin-left: 20px">
                <el-button class="el-icon-s-promotion" type="primary" @click="a('/shop/product')">发布新产品</el-button>
            </div>
        </div>
        <div class="list_height" style="width: 95%;margin: 10px 30px;overflow: auto">
            <el-table :data="tableData " stripe style="width: 100%;">
                <el-table-column v-if="shopType === 1" label="服务分类" width="250" >
                    <template slot-scope="scope">
                        <div style="display: inline-block;width: 400px;margin-left: 10px;font-size: 16px;">{{scope.row.typeName}}</div>
                    </template>
                </el-table-column>
                <el-table-column v-if="shopType === 2" label="产品分类" width="250">
                    <template slot-scope="scope">
                        <div style="display: inline-block;width: 400px;margin-left: 10px;font-size: 16px;">{{scope.row.typeName}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="shopType === 1"
                    prop="title"
                    label="服务名称"
                    width="600">
                    <template slot-scope="scope">
                        <div style="width: 84px;height: 84px;background: #D6D6D6;display: inline-block;">
                            <img :src=" scope.row.images[0].url" style="width: 84px;height: 84px;">
                        </div>
                        <div style="display: inline-block;width: 400px;margin-left: 10px;font-size: 16px;">{{ scope.row.title }}<div style="color:#999999;font-size: 14px;">id:<span>{{ scope.row.id }}</span></div></div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else
                    prop="title"
                    label="产品名称3"
                    width="600">
                    <template slot-scope="scope">
                        <div style="width: 84px;height: 84px;background: #D6D6D6;display: inline-block;">
                            <img :src=" scope.row.images[0].url" style="width: 84px;height: 84px;">
                        </div>
                        <div style="display: inline-block;width: 400px;margin-left: 10px;font-size: 16px;">{{ scope.row.title }}<div style="color:#999999;font-size: 14px;">id:<span>{{ scope.row.id }}</span></div></div>
                    </template>
                </el-table-column>
                <el-table-column  label="价格" width="150">
                    <template  slot-scope="scope">
                        <div type="success" class="el-icon el-icon-coin" style="display: inline-block;"></div>
                        <div v-if="shopType === 1" type="success" style="display: inline-block;margin-left: 5px">{{ scope.row.minPrice }}</div>
                        <div v-else type="success" style="display: inline-block;margin-left: 5px">{{ scope.row.price }}</div>
                        <label v-if="scope.row.maxPrice !== 0 ">
                            <div v-if="shopType === 1" type="success" style="display: inline-block;">-</div>
                            <div type="success" style="display: inline-block;" >{{ scope.row.maxPrice }}</div>
                        </label>
                    </template>
                </el-table-column>

<!--                <el-table-column prop="timestamp" label="创建时间" width="200">-->
<!--                    <template >-->
<!--                        <div >-->
<!--                            <div type="success">2023-06-01 10:20:24</div>-->
<!--                        </div>-->
<!--                    </template>-->
<!--                </el-table-column>-->
                <el-table-column
                    v-if="shopType === 1"
                    prop="price"
                    label="服务状态" width="200">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status === 0">
                            <el-tag type="warning" >已下架</el-tag>
                        </div>
                        <div v-if="scope.row.status === 1">
                            <el-tag type="success" >已上架</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    v-else
                    prop="price"
                    label="产品状态" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.status === 0">
                            <el-tag type="warning" >已下架</el-tag>
                        </div>
                        <div v-if="scope.row.status === 1">
                            <el-tag type="success" >已上架</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="操作" width="145">
                    <template slot-scope="scope">
                        <div type="success" class="button-column" style="display: flex;justify-content: center;align-items: center;margin-right: 70px;">
                            <label v-if="shopType === 1">
                                <el-button v-if="scope.row.status === 1" type="text" size="small" @click="stashService(scope.row)">放入仓库</el-button>
                                <el-button v-if="scope.row.status === 0" type="text" size="small" @click="stashService(scope.row)">立即上架</el-button>
                            </label>
                            <label v-if="shopType === 2">
                                <el-button v-if="scope.row.status === 1" type="text" size="small" @click="stashproduct(scope.row)">放入仓库</el-button>
                                <el-button v-if="scope.row.status === 0" type="text" size="small" @click="stashproduct(scope.row)">立即上架</el-button>
                            </label>
                            <el-button v-if="shopType === 1"  type="text" size="small" @click="editor(scope.row.id)">编辑服务内容</el-button>
                            <el-button v-if="shopType === 2" type="text" size="small" @click="editor(scope.row.id)">编辑产品内容</el-button>
                            <el-button v-if="shopType === 1" type="text" size="small" @click="deleteService(scope.row)">删除服务</el-button>
                            <el-button v-if="shopType === 2" type="text" size="small" @click="deleteproduct(scope.row)">删除产品</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>

export default {
     props:{
        shopType:{
            type:Number,
            default(){return 1}
        },
        myshop:{
            type:Object,
            default(){return {}}
        },

    },
    components: {

    },
    watch:{
        shopType:{
            handler(){

            }
        },
        myshop:{
            handler(){
                console.log(this.myshop)
            }
        },

    },
    comments:{

    },

    data() {
        return {
            keys:0,
            service_list:[{type:1,name:"全部服务",keys:"0"},{type:2,name:"出售中的服务",keys:"0"},{type:3,name:"仓库中的服务",keys:"0"}],
            service_text:[{type:1,name:"全部产品",keys:"0"},{type:2,name:"出售中的产品",keys:"0"},{type:3,name:"仓库中的产品",keys:"0"}],
            pay: 1,
            search:'',
            list:'',
            type_list:[],
            TypeList:[],
            // 最小价格
            minPrice:'',
            // 最大价格
            maxPrice:'',
            options: [{
                value: '1',
                label: '仓库中'
            }, {
                value: '2',
                label: '出售中'
            }],
            value: '',
            serviceList:[],
            GoodsList:[]
        }
    },

    mounted() {
        let that = this;
        that.getTypeList();
        that.getEquipmentTypeList();
        that.getShopServiceList();
        that.getShopGoodsList();

    },
    computed: {
        tableData() {
            if (this.shopType === 1) {
                return this.serviceList;
            } else if (this.shopType === 2) {
                return this.GoodsList;
            } else {
                return [];
            }
        },
    },

    methods: {
        // 编辑内容
        editor(id){
            if (this.shopType === 1) {
                this.$router.push({path:'/shop/addGoods',query:{id:id}});
            } else if (this.shopType === 2) {
                this.$router.push({path:'/shop/product',query:{id:id}});
            }
        },
        addswitch(type){
            this.pay = type;
        },
        // 服务分类
        getTypeList(){
            var that = this;
            that.newApi.getTypeList({
                lv: 3,
            }).then((res)=>{
                that.type_list = res.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 产品设备分类
        getEquipmentTypeList(){
            var that = this;
            that.newApi.getEquipmentTypeList({
                lv: 3,
            }).then((res)=>{
                that.TypeList = res.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 查询我的店铺
        getMyShop(){
            var that= this;
            that.newApi.getMyShop({}).then((ret)=>{
                that.myshop = ret.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        //    查询服务列表
        getShopServiceList(){
            var that= this;
            that.newApi.getShopServiceList({
                shopId:that.myshop.id,
                page:1,
                pageSize:10,
            }).then((ret)=>{
                that.serviceList = ret.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        //    查询产品列表
        getShopGoodsList(){
            var that= this;
            that.newApi.getShopGoodsList({
                type:2,
                shopId:that.myshop.id,
                page:1,
                pageSize:10,
            }).then((ret)=>{
                that.GoodsList = ret.data;
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 删除服务
        deleteService(row){
            var that= this;
            that.newApi.deleteShopService({
                id:row.id,
            }).then((ret)=>{
                that.utils.sus(ret.data);
                that.getShopServiceList()
            }).catch((err)=>{
                console.log(err)
            })
        },
         // 服务放入仓库
        stashService(row){
            var that= this;
            if (row.status == 0){
                that.status = 1
            }else if(row.status == 1){
                that.status = 0
            }
            that.newApi.updateShopServiceStatus({
                id:row.id,
                status:that.status
            }).then((ret)=>{
                that.utils.sus(ret.data);
                that.getShopServiceList()
            }).catch((err)=>{
                console.log(err)
            })
        },
        // 删除产品
        deleteproduct(row){
            var that= this;
            that.newApi.deleteShopGoods({
                id:row.id,
            }).then((ret)=>{
                that.utils.sus(ret.data);
                that.getShopGoodsList();
            }).catch((err)=>{
                console.log(err)
            })
        },
    //    产品上架
        stashproduct(row){
            var that= this;
            if (row.status == 0){
                that.status = 1
            }else if(row.status == 1){
                that.status = 0
            }
            that.newApi.updateShopGoodsStatus({
                id:row.id,
                status:that.status
            }).then((ret)=>{
                that.utils.sus(ret.data);
                that.getShopGoodsList()
            }).catch((err)=>{
                console.log(err)
            })
        }

    },

}

</script>
<style scoped>
.codes {
    font-size: 18px;
    height: 21px;
    float: left;
    cursor: pointer;
}
.text_link {
    color: #2970FF;
    border-bottom: 2px solid #2970FF;
}
/deep/ .cell {
    color: #444444;
    font-size: 16px;
}
.button-column {
    display: flex;
    flex-direction: column;
    text-align: center;
}
.list_height {
    height: 690px;
}
.list_height::-webkit-scrollbar {
    display: none;
}
</style>